import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col, Table } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
import Button from "react-bootstrap/Button";
import React, { useState, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";
import red from "../images/red.png";
import green from "../images/green.png";
import arrow from "../images/arrow.png";
import TableScrollbar from "react-table-scrollbar";

// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";
import LeadVolume from "../database/LeadVolume.json";
import LeadsByMonth from "../database/LeadsByMonth.json";
import YearToDateVisual from "../database/Year-To-Date-Visual.json";
import LeadDetailsdb from "../database/LeadDetailsDb.json";
import Header from "./Header";

export const LeadDetails = () => {
  const [ttl, setttl] = useState(0);
  const [perTa, setPerTa] = useState(0);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
  };

  function checkPer(per) {
    if (per > +25) {
      return <img src={green} width="20px" height="20px" />;
    } else if (per < +25 && per > 0) {
      return <img src={arrow} width="20px" height="20px" />;
    } else {
      return <img src={red} width="20px" height="20px" />;
    }
  }

  useEffect(() => {
    userAdd();
    userPerAdd();
  }, []);

  function userAdd() {
    const rec = LeadDetailsdb;
    var sum = 0;
    for (var i = 0; i < rec.length; i++) {
      sum += parseInt(rec[i].yearToDate);
    }
    setttl(sum);
  }

  function userPerAdd() {
    const rec = LeadDetailsdb;
    var sum = 0;
    for (var i = 0; i < rec.length; i++) {
      sum += parseInt(rec[i].change);
    }
    setPerTa(sum);
  }

  return (
    <React.Fragment>
      <Header />
      <Container fluid style={{ height: "80%" }}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "50px" }}>
                    <strong>&nbsp;&nbsp;&nbsp; Lead Details</strong>
                  </h2>
                </Col>

                <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      boxShadow: "2px 2px 8px ",

                      height: "100px",
                      width: "210px",
                      marginTop: "3px",
                      marginLeft: "52px",
                      position: "initial",
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      Total Leads Generated
                    </Card.Header>
                    <Card.Body
                      style={{ paddingTop: "6px", textAlign: "center" }}
                    >
                      <h1>17</h1>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      height: "100px",
                      width: "210px",
                      boxShadow: "2px 2px 8px ",
                      marginTop: "3px",
                      // position:'initial'
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black" }}
                    >
                      Date Range
                    </Card.Header>
                    <Card.Body style={{ paddingTop: "1px" }}>
                      <DateRangeComp />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ", position: "initial" }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ", position: "initial" }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position: "initial",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                width: "18rem",
                position: "initial",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Year
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Slider
                  {...settings}
                  className="slider"
                  style={{ margin: "1px" }}
                >
                  <div >
                    <Button variant="secondary">2017</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2018</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2019</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2020</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2021</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2022</Button>
                  </div>
                </Slider>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <Card
              style={{
                height: "412px",
                marginTop: "5px",
                boxShadow: "2px 2px 8px ",
                position: "initial",
              }}
            >
              <Card.Title
                style={{ textAlign: "center", textDecoration: "underline 2px" }}
              >
                Lead Volume
              </Card.Title>
              <Card.Body>
                <LeadsByMonthGraph
                  color="#ad5238"
                  db={LeadVolume}
                  graphType="bar"
                  height={350}
                />
              </Card.Body>
            </Card>
          </Col>
          <Col xs={9} style={{ paddingTop: "5px" }}>
            <Row>
              <Col>
                <Card
                  style={{
                    height: "200px",
                    boxShadow: "2px 2px 8px ",
                    position: "initial",
                  }}
                >
                  <Card.Subtitle
                    style={{
                      textAlign: "center",
                      textDecoration: "underline 2px",
                    }}
                  >
                    Year-To-Date-Visual
                  </Card.Subtitle>
                  <Card.Body style={{ padding: "0px" }}>
                    <LeadsByMonthGraph
                      color="green"
                      graphType="waterfall"
                      db={YearToDateVisual}
                      height={183}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row style={{ marginTop: "5px" }}>
              <Col xs={4} style={{ PaddingTop: "5px" }}>
                <Card style={{ height: "208px", boxShadow: "2px 2px 8px " }}>
                  <Card.Title
                    style={{
                      textAlign: "center",
                      textDecoration: "underline 2px",
                    }}
                  >
                    Top 5 Intrested Countries
                  </Card.Title>
                  <Card.Body className="intrest" style={{ padding: "5px" }}>
                    <Scrollbars style={{ height: "100%", width: "100%" }}>
                      <div style={{ paddingRight: "15px" }}>
                        <Card>
                          <Card.Body style={{ padding: "1px 10px" }}>
                            <Card.Subtitle>Australia</Card.Subtitle>
                            <Card.Subtitle>6456</Card.Subtitle>
                            <Card.Text>Lead</Card.Text>
                          </Card.Body>
                        </Card>
                        <Card>
                          <Card.Body style={{ padding: "1px 10px" }}>
                            <Card.Subtitle>Australia</Card.Subtitle>
                            <Card.Subtitle>6456</Card.Subtitle>
                            <Card.Text>Lead</Card.Text>
                          </Card.Body>
                        </Card>
                        <Card>
                          <Card.Body style={{ padding: "1px 10px" }}>
                            <Card.Subtitle>Australia</Card.Subtitle>
                            <Card.Subtitle>6456</Card.Subtitle>
                            <Card.Text>Lead</Card.Text>
                          </Card.Body>
                        </Card>
                        <Card>
                          <Card.Body style={{ padding: "1px 10px" }}>
                            <Card.Subtitle>Australia</Card.Subtitle>
                            <Card.Subtitle>6456</Card.Subtitle>
                            <Card.Text>Lead</Card.Text>
                          </Card.Body>
                        </Card>
                        <Card>
                          <Card.Body style={{ padding: "1px 10px" }}>
                            <Card.Subtitle>Australia</Card.Subtitle>
                            <Card.Subtitle>6456</Card.Subtitle>
                            <Card.Text>Lead</Card.Text>
                          </Card.Body>
                        </Card>
                      </div>
                    </Scrollbars>
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={8} style={{ PaddingTop: "5px" }}>
                <Card style={{ height: "80" }}>
                  <Card.Body style={{ padding: "10px", height: "205px" }}>
                    <div style={{ height: "25vh" }}>
                      <TableScrollbar rows={6}>
                        <div>
                          <Table responsive="sm" style={{ margin: "0px" }}>
                            <thead>
                              <tr
                                style={{
                                  backgroundColor: "black",
                                  color: "white",
                                }}
                              >
                                <th>Month</th>
                                <th>Year-to-Date</th>
                                <th>Leads By Month</th>
                                <th>M-O-M</th>
                                <th>Change</th>
                              </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px" }}>
                              {LeadDetailsdb.map((user) => (
                                <tr>
                                  <td>{user.month}</td>
                                  <td>{user.yearToDate}</td>
                                  <td>{user.mOM}%</td>
                                  <td>{checkPer(user.mOM)}</td>
                                  <td>{user.change}</td>
                                </tr>
                              ))}

                              <tr
                                style={{
                                  boxShadow: "2px 2px 10px 4px orangered",
                                }}
                              >
                                <td>
                                  <strong>Total:</strong>
                                </td>
                                <td>
                                  <strong>{ttl}</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td>
                                  <strong>{perTa}%</strong>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </TableScrollbar>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default LeadDetails;
